import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
	SR_PURCHASE_ORDER_LIST,
	SR_SERVICE_INDENT_LIST,
	SR_PURCHASE_ORDER_ROW_DATA,
	FILTERS_SHOW_SRQ_RIGHT_SIDEBAR,
	FILTERS_HIDE_SR_RIGHT_SIDEBAR,
	SR_PDF_DOWNNLOAD,
	MR_SR_CODE_DETAILS,
	PI_SR_CODE_DETAILS,
	SR_PO_ITEM_ACKNOWLEDGE,
	SR_PURCHASE_ORDER_CLOSE,
	SR_PURCHASE_ORDER_FOUCS_POST,
	SUBMIT_SR_EDIT_ORDER,
	VIEW_LOG_SHOW_SR_RIGHT_SIDEBAR_PURCHASE,
	VIEW_LOG_HIDE_SR_RIGHT_SIDEBAR_PURCHASE,
	SR_SERVICE_REQUEST_ROW_DATA,
	PO_SR_HISTORY,
	SR_SERVICE_REQUEST_Q_VENDORS_LIST,
	SR_SERVICE_REQUEST_QUOTATION_ADD,
	WO_AUTHORIZATION,
} from "./actionTypes";
import {
	apiError,
	PurchaseOrderListSuccessful,
	PurchaseOrderRowDataSuccessful,
	getMRCodeDetailsSuccessful,
	getPICodeDetailsSuccessful,
	POIacknowledge_close,
	getPurchaseOrderRowData,
	getPurchaseOrderList,
	getReqestRowDetails,
	SubmitEditOrderSuccessfull,
	POCancelDescription,
	POClose_modal_close,
	ToggleEditWithValue,
	PurchaseOrderHistorySuccessful,
	getPurchaseOrderHistory,
	ToggleEdit,
	getServiceIndentListSuccessful,
	getQuotationtVendorsList,
	QuotationtVendorsListSuccessful,
	getServiceRequestRequestdataSuccessful,
	GetWoAuthorizationStatusSuccessful,
	setMRErrorMessage,
} from "./actions";
import swal from "sweetalert";
import Swal from "sweetalert2";
import {
	postAdd,
	getList,
	getParamsList,
	getDownloadFile,
	postEdit,
	// postDelete,
	// getRowData,
} from "../../helpers/Helper";
// import swal from "sweetalert";
//>>>>>>>>>>>>>>>>>>>>>>>>>

function* UpdateWorkOrderAuthorizationStatus({ payload }) {
	try {
		const response = yield call(
			postEdit,
			"/workorder/woprint/status/" + payload.data.poId,
			payload.data
		);
		console.log("purchase order response info:", response);
		if (response.status === 200) {
			if (response.data.printapproval_status == 2) {
				swal("Approved Successfully.!", {
					icon: "success",
				});
			} else if (response.data.printapproval_status == 3) {
				swal("Rejected Successfully.!", {
					icon: "success",
				});
			}
			yield put(GetWoAuthorizationStatusSuccessful());
			yield put(
				getPurchaseOrderList({
					search: "",
					start_date: "",
					end_date: "",
					userdepartment: "",
					department: "",
				})
			);
		} else {
			swal("Sorry! Unable to Updated Status. Please try again!", {
				icon: "error",
			});
		}
	} catch (error) {
		if (payload.data.token !== "") {
			Swal.fire({
				icon: "error",
				text: "Server Side Issue! ",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Ok",
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.href = "/vendorlogin/" + payload.data.token;
				}
			});
		} else {
			Swal.fire({
				icon: "error",
				text: "Please Try Again! ",
			});
		}

		yield put(apiError(error));
	}
}

function* PurchaseOrderList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(getParamsList, "/workorder/list", params);

		yield put(PurchaseOrderListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getServiceIndentList() {
	try {
		const response = yield call(
			getList,
			"/serviceindent/mydeprequestsmini",
			{}
		);
		yield put(getServiceIndentListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* getServiceRequestRowdata({ payload: { rfqId } }) {
	try {
		const response = yield call(getList, "/serviceindent/" + rfqId, {});
		yield put(getServiceRequestRequestdataSuccessful(response));

		yield put(getQuotationtVendorsList());
	} catch (error) {
		yield put(apiError(error));
	}
}

function* AddQoutation({ payload: { data, qoutId, history } }) {
	try {
		if (qoutId === 0) {
			var response = {};
			if (data.token !== "") {
				response = yield call(postAdd, "/workorder/add/vendor", data);
			} else {
				response = yield call(postAdd, "/workorder/", data);
			}

			if (response.status === 201) {
				swal(" Your Work Order Added Successfully.!", {
					icon: "success",
				});
				if (data.token !== "") {
					localStorage.removeItem("access_token");
					window.location.href = "/vendorlogin/" + data.token;
				} else {
					history.push("/SrPurchaseOrderDashboard");
				}
			} else {
				swal("Sorry! Unable to add Work order. Please try again!", {
					icon: "error",
				});
			}
		} else {
			delete data.vendor_id;
			const response = yield call(postEdit, "/workorder/" + qoutId, data);

			if (response.status === 200) {
				swal("Your Work order Edited Successfully.!", {
					icon: "success",
				});
				history.push("/SrPurchaseOrderDashboard");
			} else {
				swal("Sorry! Unable to edit Work Order. Please try again!", {
					icon: "error",
				});
			}
		}
	} catch (error) {
		if (data.token !== "") {
			Swal.fire({
				icon: "error",
				text: "Work Order already Submited! ",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Ok",
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.href = "/vendorlogin/" + data.token;
				}
			});
		} else {
			Swal.fire({
				icon: "error",
				text: "Please Try Again! ",
			});
		}

		yield put(apiError(error));
	}
}

function* GetVendorData({ payload: {} }) {
	try {
		const response = yield call(getList, "/masters/mini/vendors/", {});
		yield put(QuotationtVendorsListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* PurchaseOrderRowData({ payload: { poId } }) {
	try {
		const response = yield call(getList, "/workorder/" + poId, {});
		yield put(PurchaseOrderRowDataSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* PurchaseOrderHistory({ payload: { poId, poItemId } }) {
	console.log(poId);
	try {
		const response = yield call(
			getParamsList,
			`/workorder/work-orders/history/${poId}/`,
			{ original_item_id: poItemId }
		);
		yield put(PurchaseOrderHistorySuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
// function* getMRCodeDetails({ payload: { ItemId } }) {
// 	try {
// 		const response = yield call(
// 			getList,
// 			"/workorder/srcodebywoitem/" + ItemId,
// 			{}
// 		);
// 		console.log("responsedddddddddddddddddd", response);
// 		yield put(getMRCodeDetailsSuccessful(response));
// 	} catch (error) {
// 		yield put(apiError(error));
// 	}
// }

function* getMRCodeDetails({ payload: { ItemId } }) {
	try {
		const response = yield call(
			getList,
			`/workorder/srcodebywoitem/${ItemId}`,
			{}
		);
		yield put(getMRCodeDetailsSuccessful(response));
	} catch (error) {
		const errorMessage =
			error?.response?.data?.error ||
			error?.message ||
			"Failed to fetch MR Code details. Please try again later.";
		yield call(swal, errorMessage, { icon: "error" });
		yield put(setMRErrorMessage(errorMessage));
		yield put(apiError(errorMessage));
	}
}
function* getPICodeDetails({ payload: { qitemID } }) {
	try {
		const response = yield call(
			getList,
			"/servicerequestforquotation/srcodebysrfqitem/" + qitemID,
			{}
		);
		yield put(getPICodeDetailsSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* postPOiacknowledge({ payload: { data } }) {
	try {
		const response = yield call(postAdd, "/workorder/poiacknowledge", data);
		if (response.status === 201) {
			yield put(POIacknowledge_close(false));
			yield put(getPurchaseOrderRowData(data.purchaseorder_id));
		}
	} catch (error) {
		yield put(apiError(error));
	}
}

function* AddPurchaseOrder({ payload: { data, purchaseId } }) {
	try {
		if (purchaseId === 0) {
			var response = {};
			response = yield call(postAdd, "/workorder/", data);
			if (response.status === 201) {
				swal(" Your Quotation Added Successfully.!", {
					icon: "success",
				});
			} else {
				swal("Sorry! Unable to add quotation. Please try again!", {
					icon: "error",
				});
			}
		} else {
			const response = yield call(
				postEdit,
				"/workorder/" + purchaseId,
				data
			);

			if (response.status === 200) {
				swal("Your quotation Edited Successfully.!", {
					icon: "success",
				});
				yield put(SubmitEditOrderSuccessfull());
			} else {
				swal("Sorry! Unable to edit quotation. Please try again!", {
					icon: "error",
				});
			}
		}
	} catch (error) {
		if (data.token !== "") {
			Swal.fire({
				icon: "error",
				text: "Quotation already Submited! ",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Ok",
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.href = "/vendorlogin/" + data.token;
				}
			});
		} else {
			Swal.fire({
				icon: "error",
				text: "Please Try Again! ",
			});
		}

		yield put(apiError(error));
	}
}

function* generatePDF({ payload: { POId } }) {
	try {
		yield call(getDownloadFile, "/workorder/pdf/" + POId);

		// generateRFQasPDF("RFQ",response)
	} catch (error) {
		yield put(apiError(error));
	}
}
/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
	switch (action) {
		case "add":
			if (document.body) document.body.classList.add(cssClass);
			break;
		case "remove":
			if (document.body) document.body.classList.remove(cssClass);
			break;
		default:
			if (document.body) document.body.classList.toggle(cssClass);
			break;
	}

	return true;
}

function* FilterShowRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled");
	} catch (error) {}
}
function* FilterHideRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
	} catch (error) {}
}
function* ViewLogShowRightSidebar({ payload: { purchaseId } }) {
	try {
		yield call(manageBodyClass, "timeLine-right-bar-enabled", "add");
		yield put(getPurchaseOrderRowData(purchaseId, true));
	} catch (error) {}
}
function* ViewLogHideRightSidebar() {
	try {
		yield call(manageBodyClass, "timeLine-right-bar-enabled", "remove");
	} catch (error) {}
}

function* ClosePurchaseOrder({ payload: { id, description } }) {
	try {
		const response = yield call(
			postAdd,
			"/workorder/poclose/" + id,
			description
		);
		if (response.status === 200) {
			swal("Your Purchase Order has been closed!", {
				icon: "success",
			});
			yield put(
				POCancelDescription({
					key: "description",
					value: "",
				})
			);
			yield put(POClose_modal_close());
			yield put(
				getPurchaseOrderList({
					search: "",
					start_date: "",
					end_date: "",
					userdepartment: "",
					department: "",
				})
			);
			// yield put(SetParams({
			//   mrstatus: [0],
			//   pistatus: [0],
			//   mistatus: [0],
			//   search: "",
			//   start_date: "",
			//   end_date: "",
			//   userdepartment: "",
			//   departments: "",
			// }))
		} else {
			swal("Sorry! Your Purchase Order has been not closed!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

function* FocusPostPurchaseOrder({ payload: { id } }) {
	try {
		const response = yield call(
			postAdd,
			"/thirdparty/fsyncworkeorder/" + id
		);
		if (response.status === 200) {
			if (response.data.result == true) {
				swal({
					title: response.data.msg,
					icon: "error",
				});
			} else {
				swal({
					title: response.data.msg,
					icon: "error",
				});
			}
			yield put(
				getPurchaseOrderList({
					search: "",
					start_date: "",
					end_date: "",
					userdepartment: "",
					department: "",
				})
			);
		} else {
			swal(
				"Sorry! selected Purchase is not posted on focus. please try again!",
				{
					icon: "error",
				}
			);
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});
		yield put(apiError(error));
	}
}

export function* watchgetPurchaseOrderList() {
	yield takeEvery(SR_PURCHASE_ORDER_LIST, PurchaseOrderList);
}
export function* watchgetServiceIndentList() {
	yield takeEvery(SR_SERVICE_INDENT_LIST, getServiceIndentList);
}
export function* watchPurchaseOrderRowData() {
	yield takeEvery(SR_PURCHASE_ORDER_ROW_DATA, PurchaseOrderRowData);
}
export function* watchgetServiceRequestRowdata() {
	yield takeEvery(SR_SERVICE_REQUEST_ROW_DATA, getServiceRequestRowdata);
}
export function* watchGetVendorData() {
	yield takeEvery(SR_SERVICE_REQUEST_Q_VENDORS_LIST, GetVendorData);
}
export function* watchgetMRCodeDetails() {
	yield takeEvery(MR_SR_CODE_DETAILS, getMRCodeDetails);
}
export function* watchQoutationAdd() {
	yield takeEvery(SR_SERVICE_REQUEST_QUOTATION_ADD, AddQoutation);
}
export function* watchgetPICodeDetails() {
	yield takeEvery(PI_SR_CODE_DETAILS, getPICodeDetails);
}
export function* watchPostPOiacknowledge() {
	yield takeEvery(SR_PO_ITEM_ACKNOWLEDGE, postPOiacknowledge);
}
export function* watchAddPurchaseOrder() {
	yield takeEvery(SUBMIT_SR_EDIT_ORDER, AddPurchaseOrder);
}
export function* watchUpdateWorkOrderAuthorizationStatus() {
	yield takeEvery(WO_AUTHORIZATION, UpdateWorkOrderAuthorizationStatus);
}
export function* watchFilterShowRightSidebar() {
	yield takeEvery(FILTERS_SHOW_SRQ_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
	yield takeEvery(FILTERS_HIDE_SR_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchViewLogShowRightSidebar() {
	yield takeEvery(
		VIEW_LOG_SHOW_SR_RIGHT_SIDEBAR_PURCHASE,
		ViewLogShowRightSidebar
	);
}
export function* watchPurchaseOrderHistory() {
	yield takeEvery(PO_SR_HISTORY, PurchaseOrderHistory);
}
export function* watchViewLogHideRightSidebar() {
	yield takeEvery(
		VIEW_LOG_HIDE_SR_RIGHT_SIDEBAR_PURCHASE,
		ViewLogHideRightSidebar
	);
}

export function* watchgeneratePDF() {
	yield takeEvery(SR_PDF_DOWNNLOAD, generatePDF);
}

export function* watchPurchaseOrderClose() {
	yield takeEvery(SR_PURCHASE_ORDER_CLOSE, ClosePurchaseOrder);
}
export function* watchPoFoucsPost() {
	yield takeEvery(SR_PURCHASE_ORDER_FOUCS_POST, FocusPostPurchaseOrder);
}
function* SRPurchaseOrderSaga() {
	yield all([
		fork(watchgetPurchaseOrderList),
		fork(watchQoutationAdd),
		fork(watchgetServiceIndentList),
		fork(watchgetServiceRequestRowdata),
		fork(watchPurchaseOrderRowData),
		fork(watchGetVendorData),
		fork(watchgetMRCodeDetails),
		fork(watchgetPICodeDetails),
		fork(watchFilterShowRightSidebar),
		fork(watchfilterHideRightSidebarr),
		fork(watchViewLogShowRightSidebar),
		fork(watchPurchaseOrderHistory),
		fork(watchViewLogHideRightSidebar),
		fork(watchgeneratePDF),
		fork(watchPostPOiacknowledge),
		fork(watchPurchaseOrderClose),
		fork(watchPoFoucsPost),
		fork(watchAddPurchaseOrder),
		fork(watchUpdateWorkOrderAuthorizationStatus),
	]);
}

export default SRPurchaseOrderSaga;
